import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Gallery from './components/Gallery';
import Kitesurf from './components/Kitesurf';
import Booking from './components/Booking';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { Toaster } from './components/ui/sonner';

function Home({ lang }) {
  return (
    <div className="App">
      <Header lang={lang} />
      <Hero lang={lang} />
      <About lang={lang} />
      <Gallery lang={lang} />
      <Kitesurf lang={lang} />
      <Booking lang={lang} />
      <Contact lang={lang} />
      <Footer lang={lang} />
      <Toaster />
    </div>
  );
}

export default Home;